import { useEffect } from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";

import Page from "common/Page";
import logo from "common/images/Pageant-media.png";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    iframeWrap: {
      height: "990px",
      [theme.breakpoints.up("xs")]: {
        height: "900px",
      },
      [theme.breakpoints.up("md")]: {
        height: "580px",
      },
    },
    iframe: {},
  })
);

export default function SubscribeUs() {
  const classes = useStyles();
  useEffect(() => {
    document.title = "Subscribe Us";
  }, []);

  return (
    <Page className={classes.root} title="Subscribe Us">
      <Container maxWidth={false}>
        <Box p={1} m={1} justifyContent="center" textAlign="center"></Box>
        <Box className={classes.iframeWrap}>
          <iframe
            allowTransparency
            title="iframe-subscribe-demo"
            src="https://pardot.pageantmedia.com/l/284832/2021-07-29/dztg8k"
            width="100%"
            height="100%"
            className={classes.iframe}
            frameBorder={0}
          />
        </Box>
      </Container>
    </Page>
  );
}
